import { formatDollars } from '~/utils/formatNumber';
import { display } from '~/utils/displayValues/common';
import { UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import getDisplayValueCosts from './getDisiplayValueCosts';

export default function budgetFees(project: Project, projectCosts: any, permissions: any) {
  const projectCostsData = getDisplayValueCosts(project, projectCosts);
  const { data, overall, perWdc, perKwh, bid } = projectCostsData || {};

  let isTBD: boolean = false;

  if (data?.isRejectedBid) {
    isTBD = true;
  }

  if (data?.hasPercentFees && !bid?.amount) {
    isTBD = true;
  }

  const totalSizeWatts = project?.projectArrays
    ? Object.values(project.projectArrays).reduce((acc: number, arr: any) => acc + Number(arr.sizeKwdc), 0) * 1000
    : 0;

  // Raw values for buyer fees
  const buyerTotalRaw = overall?.nrsFee ?? 0;
  const buyerWdcRaw = perWdc?.nrsFee ?? 0;
  const buyerStorageTotalRaw = overall?.buyerStorageFee ?? 0;
  const buyerStoragePerWdcRaw = perWdc?.buyerStorageFee ?? 0;
  const buyerCombinedTotalRaw = buyerTotalRaw + buyerStorageTotalRaw;
  const buyerCombinedPerWdcRaw = (buyerCombinedTotalRaw / totalSizeWatts).toFixed(3);

  // Raw values for seller fees
  const sellerTotalRaw = overall?.sellerFee ?? 0;
  const sellerWdcRaw = perWdc?.sellerFee ?? 0;
  const sellerStorageTotalRaw = overall?.sellerStorageFee ?? 0;
  const sellerStoragePerWdcRaw = perWdc?.sellerStorageFee ?? 0;
  const sellerCombinedTotalRaw = sellerTotalRaw + sellerStorageTotalRaw;
  const sellerCombinedPerWdcRaw = sellerWdcRaw + sellerStoragePerWdcRaw;

  // Display values for buyer fees
  const buyerFeeTotal = isTBD ? 'TBD' : display(formatDollars(buyerTotalRaw, { dec: UnitDecimals.TOTAL }));
  const buyerFeeWdc = isTBD ? 'TBD' : display(formatDollars(buyerWdcRaw, { dec: UnitDecimals.WDC }));
  const buyerStorageFeeOverall = isTBD ? 'TBD' : display(formatDollars(buyerStorageTotalRaw, { dec: UnitDecimals.TOTAL }));
  const buyerStorageFeePerWdc = isTBD ? 'TBD' : display(formatDollars(buyerStoragePerWdcRaw, { dec: UnitDecimals.WDC }));
  const buyerCombinedFeeTotal = isTBD ? 'TBD' : display(formatDollars(buyerCombinedTotalRaw, { dec: UnitDecimals.TOTAL }));
  const buyerCombinedFeePerWdc = isTBD ? 'TBD' : display(formatDollars(buyerCombinedPerWdcRaw, { dec: UnitDecimals.WDC }));

  // Display values for seller fees
  const sellerFeeTotal = isTBD ? 'TBD' : display(formatDollars(sellerTotalRaw, { dec: UnitDecimals.TOTAL }));
  const sellerFeeWdc = isTBD ? 'TBD' : display(formatDollars(sellerWdcRaw, { dec: UnitDecimals.WDC }));
  const sellerStorageFeeOverall = isTBD ? 'TBD' : display(formatDollars(sellerStorageTotalRaw, { dec: UnitDecimals.TOTAL }));
  const sellerStorageFeePerWdc = isTBD ? 'TBD' : display(formatDollars(sellerStoragePerWdcRaw, { dec: UnitDecimals.WDC }));
  const sellerCombinedFeeTotal = isTBD ? 'TBD' : display(formatDollars(sellerCombinedTotalRaw, { dec: UnitDecimals.TOTAL }));
  const sellerCombinedFeePerWdc = isTBD ? 'TBD' : display(formatDollars(sellerCombinedPerWdcRaw, { dec: UnitDecimals.WDC }));
  
  return {
    showBuyerFees: overall?.showBuyerFees,
    showSellerFees: overall?.showSellerFees,
    showBuyerStorageFees: overall?.showBuyerStorageFees,
    showSellerStorageFees: overall?.showSellerStorageFees,
    hasPercentFees: data?.hasPercentFees,
    isTBD,
    // Buyer fee data
    buyer: {
      raw: {
        total: buyerTotalRaw,
        wdc: buyerWdcRaw,
        storageOverall: buyerStorageTotalRaw,
        storagePerWdc: buyerStoragePerWdcRaw,
        storagePerKwh: perKwh?.buyerStorageFee ?? 0,
        combinedTotal: buyerCombinedTotalRaw,
        combinedPerWdc: buyerCombinedPerWdcRaw,
      },
      display: {
        feeTotal: buyerFeeTotal,
        feeWdc: buyerFeeWdc,
        storageFeeOverall: buyerStorageFeeOverall,
        storageFeePerWdc: buyerStorageFeePerWdc,
        combinedFeeTotal: buyerCombinedFeeTotal,
        combinedFeePerWdc: buyerCombinedFeePerWdc,
        storagePerKwh: display(formatDollars(perKwh?.buyerStorageFee ?? 0, { dec: 2 })),
      },
    },
    // Seller fee data
    seller: {
      raw: {
        total: sellerTotalRaw,
        wdc: sellerWdcRaw,
        storageOverall: sellerStorageTotalRaw,
        storagePerWdc: sellerStoragePerWdcRaw,
        storagePerKwh: perKwh?.sellerStorageFee ?? 0,
        combinedTotal: sellerCombinedTotalRaw,
        combinedPerWdc: sellerCombinedPerWdcRaw,
      },
      display: {
        feeTotal: sellerFeeTotal,
        feeWdc: sellerFeeWdc,
        storageFeeOverall: sellerStorageFeeOverall,
        storageFeePerWdc: sellerStorageFeePerWdc,
        storagePerKwh: display(formatDollars(perKwh?.sellerStorageFee ?? 0, { dec: 2 })),
        combinedFeeTotal: sellerCombinedFeeTotal,
        combinedFeePerWdc: sellerCombinedFeePerWdc,
      },
    }
  };
}